import React from "react"
import { defineMessages } from "react-intl"
import { useSelector } from "react-redux"
import GenericMenu from "./GenericMenu"
import appConfig from "../../AppConfig"
import pluginMessages from "./mainMenuIntl"

const messages = {
  ...defineMessages({
    home: {
      defaultMessage: "Home",
      id: "menu.home"
    },
    am: {
      defaultMessage: "Our funds",
      id: "menu.AM"
    },
    wealth: {
      defaultMessage: "Asset Management",
      id: "menu.wealth"
    },
    documents: {
      defaultMessage: "Documents",
      id: "menu.wealth.documents"
    },
    form: {
      defaultMessage: "Forms Creation",
      id: "forms.creation"
    }
  }),
  ...pluginMessages
}

export default function MainMenu() {
  const routes = []
  const pagesInfos = useSelector((state) => state.pages?.pagesInfos)
  const allPagesHidden =
    Boolean(pagesInfos) &&
    Object.values(pagesInfos).every((page) => page.isHidden)

  if (appConfig.showWealthPage && !allPagesHidden) {
    routes.push({
      path: "/wealth",
      title: messages.wealth,
      isVisible: () => true
    })
  }

  routes.push({
    path: "/documents",
    title: messages.documents,
    withBadge: true,
    isVisible: (isLoggedIn) => isLoggedIn
  })

  return <GenericMenu routes={routes} subMenu={false} />
}
